<template>
  <div
    class="three-dim-multipal-player"
    style="width: 100%; height: 100%; display: flex; flex-flow: row wrap"
  >
    <div class="forVideo" :style="`width:100%;height: 100%;display:flex;flex-wrap:wrap`"></div>
  </div>
</template>

<script>
import axios from 'axios'

import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()

export default {
  props: {
    code: {
      type: Array,
      defalut: [],
    },
    // 9宫格 | 4宫格
    typeNum: {
      type: Number,
      default: () => {
        return 6
      },
    },
  },
  watch: {
    code: {
      handler(val) {
        this.getConfig()
      },
      deep: true,
    },
  },
  created() {},
  async mounted() {
    await this.getConfig()
  },
  data() {
    return {
      ipAddress: '',
      username: '',
      password: '',
      port: '',
      idArr: [],
    }
  },
  beforeDestroy() {},
  methods: {
    async getConfig() {
      const pIid = _.get(this.code[0], 'pIid') // 电视墙重复渲染问题 取监控列表的第一条数据的pIid获取config
      const [err, res] = await iotDeviceProtocolInstanceApi.get(pIid)
      if (!err) {
        const parsedInfo = JSON.parse(res.jsonContent)
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    async login() {
      const _this = this
      axios({
        method: 'POST',
        url: `http://${this.ipAddress}:${this.port}/VIID/login/v2`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          const accessCode = res.data.AccessCode
          const md1 = forge.md.md5.create() // md5
          const md2 = forge.md.md5.create() // md5
          md1.update(_this.password) // md5
          const passwordMd5 = md1.digest().toHex() // md5
          const base64Username = window.btoa(_this.username)
          const loginSignatureTemp = base64Username + accessCode + passwordMd5
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          const data = {
            UserName: _this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          axios({
            method: 'POST',
            url: `http://${_this.ipAddress}:${_this.port}/VIID/login/v2`,
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            responseType: 'json',
            data,
          })
            .then((r) => {
              const loginResult = r.data.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  break
                case 12351:
                  break
                case undefined:
                  window.playerToken = r.data.AccessToken
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  const url = window.location.host
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 9, '/unv/imosSdk.html')
                    .then(() => {
                      // 设置后续事件回调
                      imosSdk.registerLiveMsg((result) => {
                        if (result.Type === 'zoom' && result.Zoom === 1) {
                          let id = ''
                          for (let j = 0; j < _this.idArr.length; j += 1) {
                            if (_this.idArr[j].code === result.CameraCode) {
                              id = _this.idArr[j].id

                              imosSdk.playLive(id, _this.idArr[j].code, _this.idArr[j].code, 1)
                              if (_this.idArr[j].addId) {
                                securityDeviceServe.setMonitorNumber(_this.idArr[j].addId)
                                return
                              }
                            }
                          }
                        }
                        if (result.Type === 'zoom' && result.Zoom === 0) {
                          let id = ''
                          for (let j = 0; j < _this.idArr.length; j += 1) {
                            if (_this.idArr[j].code === result.CameraCode) {
                              id = _this.idArr[j].id
                              imosSdk.playLive(id, _this.idArr[j].code, _this.idArr[j].code, 2)
                              return
                            }
                          }
                        }
                      })
                    })
                    .then(() => {})
                    .catch((err) => {})
                  break

                default:
                  break
              }
              const videoDom = document.getElementsByClassName('forVideo')[0]
              videoDom.innerHTML = ''
              _this.idArr = []
              _this.code.forEach((item) => {
                _this.creatWindow(item)
              })
            })
            .catch((e) => {})
        })
        .catch((error) => {})
    },
    creatWindow(item) {
      if (!window.playerToken) {
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      const obj = {
        code: item.code,
        id: iframeObj.id,
        addId: item.id,
      }
      this.idArr.push(obj)
      this.createSpeDiv(iframeObj, item)
    },
    createSpeDiv(iframeObj, item) {
      const videoDom = document.getElementsByClassName('forVideo')[0]
      let divDom = document.createElement('div')
      // 设置样式
      // 12宫格样式
      if (this.typeNum === 12) {
        divDom.style.height = '32%'
        divDom.style.width = '20%'
        divDom.style.marginLeft = '4%'
        // 6宫格样式
      } else if (this.typeNum === 6) {
        divDom.style.height = '48%'
        divDom.style.width = '31%'
        divDom.style.marginLeft = '1.75%'
      }
      const divDomName = document.createElement('div')
      divDomName.innerHTML = `${item.name}`
      divDomName.style.fontSize = '12px'
      divDomName.style.textAlign = 'start'
      divDomName.style.padding = '1%'
      divDomName.style.height = '28px'
      divDom.appendChild(divDomName)
      divDom.appendChild(iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      this.playLive(iframeObj.id, item)
    },
    playLive(iframeId, item) {
      if (!window.playerToken) {
        return
      }
      imosSdk.playLive(
        iframeId, // 设置摄像头Id
        item.code, // 设置摄像头code
        item.code, // 设置摄像头code
        (e) => {},
        2
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.three-dim-multipal-player {
  ::v-deep .imosSdk-video {
    width: 100% !important;
    height: calc(100% - 28px) !important;
  }
}
.forVideo {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
